module.exports = __webpack_public_path__ + "img/logistic-2.c04d207c.png";